export const OperacionTransferenciaTercerosFields = {
  CodPais: 'codPais',
  NombrePais: 'nombrePais',
  CodEstado: 'codOperacionTransferenciaTercerosEstado',
  DescEstado: 'descOperacionTransferenciaTercerosEstado',
  AsesorFinanciero: 'asesorFinanciero',
  NroOperacion: 'nroOperacion',
  Finalizada: 'finalizada',
  FechaAprobacion: 'fechaAprobacion',
  FechaAlta: 'fechaAlta',
  IdUsuarioAlta: 'idUsuarioAlta',
  BitEnvio: 'enviar',
  PermiteEditar: 'permiteEditarOperacion',
  PermiteEliminar: 'permiteEliminarOperacion',
  NombreUsuarioAlta: 'nombreUsuarioAlta',
  ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
  MailUsuarioAlta: 'mailUsuarioAlta',
  Cuentas: 'cuentas',
  VisualizaExpandidoCompliance: 'visualizaExpandidoCompliance',
  PermiteEditarCompliance: 'permiteEditarCompliance',
  VisualizaExpandidoFinalizar: 'visualizaExpandidoFinalizar',
  PermiteEditarFinalizar: 'permiteEditarFinalizar',
} as const

export const OperacionTransferenciaTercerosCuentaFields = {
  NroCuenta: 'nroCuenta',
  Titular: 'titular',
  CodTipoOperacion: 'codTipoOperacion',
  TipoOperacion: 'descTipoOperacion',
  Broker: 'broker',
  MSB: 'MSB',
  BancoReceptor: 'bancoReceptor',
  TitularCuenta: 'titularCuenta',
  Detalles: 'detalles',
  PermiteModificar: 'permiteModificar',
  Estilo: 'estilo'
} as const

export const OperacionTransferenciaTercerosDetalleFields = {
  Moneda: 'moneda',
  Monto: 'monto',
  MontoEquivalenteUSD: 'montoEquivalenteUSD',
  Destino: 'destino',
  Sector: 'descOperacionTransferenciaTercerosCuentaDetalleSeccion',
  PermiteModificar: 'permiteModificar',
} as const

export const OperacionTransferenciasTercerosChequeosComplianceFields = {
  IdOperacionTransferenciasTerceros: 'idOperacionTransferenciasTerceros',
  MotivoCliente: 'motivoCliente',
  RecibidaInstruccion: 'recibidaInstruccion',
  DocumentacionEnOrden: 'documentacionEnOrden',
  BeneficiarioRegulado: 'beneficiarioRegulado',
  InstruccionFirmada: 'instruccionFirmada',
  PagoDirecto: 'pagoDirecto',
  DetallePagoDirecto: 'detallePagoDirecto',
  HitBusqueda: 'hitBusqueda',
  DetalleHitBusqueda: 'detalleHitBusqueda',
  Callback: 'callback',
  DetalleCallback: 'detalleCallback',
  Opinion: 'opinion',
  Situacion: 'situacion',
  Activo: 'activo'
} as const;